module.exports = __webpack_public_path__ + "static/media/Bluelab Multimedia pH Meter.4057e279.webp";